@if (visible()) {
  @for (child of block().children; track child['_uid']; let i = $index) {
    <s1-cms-component [blok]="child"/>
  }
}
